/**
 * Clear authentication state from all stores
 */
export function clearAuthStore() {
  if (typeof window === 'undefined') return

  console.log('🗑️ [ClearAuthStore] Clearing auth stores...')

  // Очищаем все auth-related localStorage keys
  const authKeys = [
    'auth-storage',      // Zustand persist
    'user-storage',
    'auth-state',
    'user',
    'auth',
    'token',
    'session',
  ]

  authKeys.forEach(key => {
    if (localStorage.getItem(key)) {
      console.log(`  - Removing: ${key}`)
      localStorage.removeItem(key)
    }
  })

  // Очищаем Zustand stores напрямую (если они есть)
  try {
    // Импортируйте ваши stores и вызовите их reset методы
    // Например:
    // import { useAuthStore } from '@/stores/useAuthStore'
    // useAuthStore.getState().reset?.()
    
    console.log('✅ [ClearAuthStore] All stores cleared')
  } catch (error) {
    console.error('❌ [ClearAuthStore] Error clearing stores:', error)
  }
}
